import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GameSelectionDialog from './GameSelectionDialog';
import './PracticeGames.css';

const PracticeGames = () => {
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);

  const handleGameClick = (gameType) => {
    if (gameType === 'recall') {
      setSelectedGame('recall');
      setShowDialog(true);
    } else if (gameType === 'cue') {
      // Cue game is disabled for now
      alert('Cue game is coming soon!');
    }
  };

  const handleDialogClose = () => {
    setShowDialog(false);
    setSelectedGame(null);
  };

  const handleGameStart = (tagId, totalQuestions) => {
    const searchParams = new URLSearchParams();

    if (Number.isInteger(totalQuestions)) {
      searchParams.set('questions', String(totalQuestions));
    }

    const search = searchParams.toString();

    // Navigate to practice session with the selected tag and requested drill length
    navigate(`/practice/recall/${tagId}${search ? `?${search}` : ''}`);
  };

  return (
    <div className="practice-games">
      <div className="practice-games-header">
        <h2>Practice Modes</h2>
        <p>Choose a guided mode and start a conversational recall session.</p>
      </div>

      <div className="games-grid">
        <div 
          className="game-card recall-game"
          onClick={() => handleGameClick('recall')}
        >
          <div className="game-icon">RC</div>
          <h3>Recall Session</h3>
          <p>Practice pulling lines from memory and adapting them into a response.</p>
          <div className="game-status active">Available</div>
        </div>

        <div 
          className="game-card cue-game disabled"
          onClick={() => handleGameClick('cue')}
        >
          <div className="game-icon">CQ</div>
          <h3>Cue Session</h3>
          <p>Practice live cue-response rehearsal with a more directed prompt flow.</p>
          <div className="game-status disabled">Coming Soon</div>
        </div>
      </div>

      {showDialog && (
        <GameSelectionDialog
          gameType={selectedGame}
          onClose={handleDialogClose}
          onStart={handleGameStart}
        />
      )}
    </div>
  );
};

export default PracticeGames;
